import { ArrowIcon } from '@modusign/design-system';
import { ReactNode } from 'react';
import { useDispatch } from 'react-redux';

import { modalClose } from '@app/store/modal/actions';

interface AlertWithLinkModalProps {
  content: string;
  // https://developer.mozilla.org/ko/docs/Web/HTML/Element/a#attr-target
  linkTarget?: '_self' | '_blank' | '_parent' | '_top';
  linkTextElement: ReactNode;
  linkUrl: string;
  title: string;
}

const defaultProps = {
  linkTextElement: (
    <>
      <button className="TextBtn TextBtn--gray TextBtn--underline" type="button">
        자세히 알아보기 <ArrowIcon direction="right" ml="2px" />
      </button>
    </>
  ),
};

function AlertWithLinkModal({
  content,
  linkTarget,
  linkTextElement,
  linkUrl,
  title,
}: AlertWithLinkModalProps) {
  const dispatch = useDispatch();
  const splitedContent = content.split('\n');
  return (
    <div className="Container Container--max-xxs">
      <div className="Card Card--pop align-center box-6x">
        {title && (
          <h4 className="space-2x" data-testid="basic-modal-title">
            <strong>{title}</strong>
          </h4>
        )}
        <p className="space-3x" data-testid="basic-modal-content">
          {splitedContent.map((v, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <span key={index}>
              {v}
              <br />
            </span> // eslint-disable-line react/no-array-index-key
          ))}
        </p>
        <div className="space-5x">
          <a href={linkUrl} rel="noreferrer noopener" target={linkTarget}>
            {linkTextElement}
          </a>
        </div>
        <button
          className="Btn Btn--primary Btn--bold-mobile"
          data-testid="basic-modal-close-button"
          type="button"
          onClick={() => {
            dispatch(modalClose());
          }}
        >
          확인
        </button>
      </div>
    </div>
  );
}

AlertWithLinkModal.defaultProps = defaultProps;

export default AlertWithLinkModal;
